<div class="card mx-auto " style="max-width: 500px;">
    <div class="card-body ">
      <h4>Login</h4>
      <div class="mb-3">
        <label>Username</label>
        <input [(ngModel)]="username" name="username" class="form-control" />
      </div>
  
      <div class="mb-3">
        <label>Password</label>
        <div class="input-group">
          <input
            [type]="showPassword ? 'text' : 'password'"
            [(ngModel)]="password"
            name="password"
            class="form-control"
          />
          <button class="btn btn-outline-secondary" (click)="toggleShowPassword()">
            {{ showPassword ? 'Hide' : 'Show' }}
          </button>
        </div>
      </div>
  
      <div class="form-check mb-3">
        <input type="checkbox" [(ngModel)]="rememberMe" name="rememberMe" class="form-check-input" id="rememberCheck" />
        <label for="rememberCheck" class="form-check-label">Remember Me</label>
      </div>
  
      <button class="btn btn-primary" (click)="onLogin()">Login</button>
      <button class="btn btn-link" (click)="onForgot()">Forgot Password?</button>
    </div>
  </div>
  
